import __request__ from "routing/request";
export function getAllEntityScopes(requestOptions) {
  return __request__("GET", "/entity_scopes", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
